import Vue from 'vue'
import config from '@/config'
import stylus from '@/stylesheets/stylus'

interface ObservableWindow {
    minSupportedViewportWidth: number
    minSupportedViewportHeight: number
    defaultUnit: number
    width: number
    height: number
    horizontalUnitInPixels: number
    verticalUnitInPixels: number
    horizontalUnitInViewportUnits: string
    verticalUnitInViewportUnits: string
    currentUnitInPixels: number
    currentScale: number
}

const getWindowData = (): ObservableWindow => {
    const minSupportedViewportWidth = config.UI.MINIMUM_VIEWPORT_WIDTH_BEFORE_SCALING
    const minSupportedViewportHeight = config.UI.MINIMUM_VIEWPORT_HEIGHT_BEFORE_SCALING
    const defaultUnit = stylus.$unit as number

    const width = window.innerWidth
    const height = window.innerHeight

    const horizontalUnitInPixels = defaultUnit/minSupportedViewportWidth * width
    const verticalUnitInPixels = defaultUnit/minSupportedViewportHeight * height
    const horizontalUnitInViewportUnits = `${100 * defaultUnit/minSupportedViewportWidth}vw`
    const verticalUnitInViewportUnits = `${100 * defaultUnit/minSupportedViewportHeight}vh`

    const currentUnitInPixels = Math.min(defaultUnit, horizontalUnitInPixels, verticalUnitInPixels)
    const currentScale = Math.min(defaultUnit, horizontalUnitInPixels, verticalUnitInPixels) / defaultUnit

    return {
        minSupportedViewportWidth,
        minSupportedViewportHeight,
        defaultUnit,

        width,
        height,
        horizontalUnitInPixels,
        verticalUnitInPixels,
        horizontalUnitInViewportUnits,
        verticalUnitInViewportUnits,
        currentUnitInPixels,
        currentScale,
    }
}

const observableWindow = Vue.observable(getWindowData())
window.addEventListener('resize', () => {
    Object.entries(getWindowData()).forEach(([key, value]) => {
        observableWindow[key as keyof ObservableWindow] = value
    })
})

export default observableWindow
